"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypographyTags = void 0;
var TypographyTags;
exports.TypographyTags = TypographyTags;

(function (TypographyTags) {
  TypographyTags["DIV"] = "div";
  TypographyTags["SPAN"] = "span";
  TypographyTags["P"] = "p";
})(TypographyTags || (exports.TypographyTags = TypographyTags = {}));